import React, {useEffect, useState} from "react";

export default function FormGroup(props){

    let icon = false
    const [error, setError] = useState(props.error)

    if(props.icon){
        icon =  <span className="input-group-text">
            <i className={'icon icon-' + props.icon}>
            </i>
        </span>
    }

    const isHorizontal = () => {
        if(props.horizontal){
            return ' form-group_horizontal'
        }
    }

    useEffect(() => {
        setError(props.error)
    }, [props]);

    return (
        <div className={'form-group ' + (props.class ? props.class : '') + isHorizontal()} style={props.style ? props.style : null}>
            <label {...props.labelOptions}>{props.label}</label>
            <div className="input-group">

                {icon}
                {props.children}


            </div>
            {error ?
            <small className="p-error">{error}</small>
                : <small className="p-error">&nbsp;</small>}
        </div>
    )
}